var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.17 255.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.82,0c4.93,3.49,10.37,6.44,14.71,10.56C73,21.4,84,32.72,95.06,43.9c10.11,10.17,10,20-.1,30.18C88,81,81.08,87.9,74.2,94.86c-4.23,4.29-4.58,7.43-1.11,12.34a307.74,307.74,0,0,0,74.56,74.61c5.14,3.63,8.18,3.26,12.72-1.23,7.31-7.24,14.55-14.55,21.84-21.81,8-8,18-8.91,26.13-1.23q21.32,20.19,41.54,41.51c7.65,8,6.75,18.23-1.11,26.15-4.56,4.59-9.41,8.92-13.67,13.77-12.55,14.31-28.75,17.52-46.55,15.52-24.42-2.75-46.26-12.67-66.71-25.66C76.41,200,40.29,162.27,15.58,114.17,8.2,99.8,2.79,84.69.75,68.54A7.32,7.32,0,0,0,0,66.74V49.81c.33-1.09.75-2.16,1-3.27C2.79,37.27,6.43,29,13.53,22.44,18.37,18,22.73,13,27.62,8.53,31.09,5.39,35.09,2.82,38.85,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.611e3d7ec08e8e582e939e0ef945e348.svg";
export { ForwardRef as ReactComponent };